import Api from '@/services/Api'

export default {
  updateLang (id, data) {
    return Api().put(`/users/${id}/language`, data)
  }
}



// WEBPACK FOOTER //
// ./src/services/UserService.js